/**
 * Returns true when the pathname belongs to a public event page that must be
 * accessible to unauthenticated visitors. Matches:
 *   /e/<id>
 *   /e/<id>/register
 *   /e/<id>/ticket
 *
 * Captured once on mount so the decision is stable for the lifetime of the
 * page load, even if the user later navigates client-side to a protected route.
 */
export function isPublicEventPath(pathname: string): boolean {
  return /^\/e\/[^/]/.test(pathname)
}
